module.exports = __webpack_public_path__ + "img/preview.16488cbc.webp";